module.exports = __webpack_public_path__ + "static/media/speaker_identification_demo.ac25452a.png";